import { PayMCopyDateModelType, PayMCopyDateStatusKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import TableWithCustomVirtualListing from '../../../../../../../../baseComponents/TwinTable/TableWithCustomVirtualListing'
import { CustomRenderString } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { ColumnOrderTableSchema } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { PayMCopyDateModelTypeComplete } from '../../ModalMarkRemittanceAsPaid/ModalSelectRemittanceAsPaid/types'
import useConfigColumns from '../../../../../../../../utils/hooks/useConfigColumns'
import { useCallback, useMemo, useState } from 'react'
import { ColumnITLayoutTableConfiguration } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { DictionaryComponents } from '../../../../../../../../utils/globals/types'
import { ColumnConfiguration } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import Checkbox from '../../../../../../../../forms/Checkbox'
import { sellOrderLayoutComponents } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { ITCheckboxProps } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { ModalFullCentered } from '../../../../../../../../baseComponents/Modal'
import { InputCalendarStateFull } from '../../../../../../../../forms/Input/InputCalendar'
import { GroupPaymentMethodDateTy, SetGroupPaymentMethodDateTy } from './types'
import { RectangularInputPrice } from '../../../../../../../../forms/Input/InputPrice'
import { CustomSelectWithSearchBar } from '../../../../../../../../forms/CustomSelect'
import { emptyExtraLineFirstSortFunction } from '../../../../../../../../forms/CustomSelect/functions'
import { DictPaymentTypesTy } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/types'
import NullComponent from '../../../../../../../../baseComponents/NullComponent'
import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { ButtonDisabledOrLoader, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { parsePaymentMethodDatesToGroup } from './functions'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { DisplayStatus } from '../../../../../../../../baseComponents/Displays/DisplayStatus'
import useCollectionAndPaymentStatus from '../../../../../../../../utils/hooks/accounting/useCollectionAndPaymentStatus'
import { SetEditPaymentMethodModalTy } from '../types'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import { getISOCurrencyMain } from '../../../../../../../../utils/reducers/getters'
import './modal_group_payment_method_date.sass'
import { getStartOfDay } from '../../../../../../../../utils/globals/date'

interface ModalGroupPaymentMethodDateBaseProps {
    paymentTypesMemo: TwinDictionary
    dictPaymentTypes: DictPaymentTypesTy
    paymentCopyDates: PayMCopyDateModelType[]
    onSubmit: () => void
    setOpened: SetEditPaymentMethodModalTy
}

interface ModalGroupPaymentMethodDateProps extends ModalGroupPaymentMethodDateBaseProps {
}

const ModalGroupPaymentMethodDate: React.FC<ModalGroupPaymentMethodDateProps> = ({ paymentCopyDates, setOpened, paymentTypesMemo, dictPaymentTypes, ...logic }) => {
    const {t} = useTwinTranslation()
    const { collectionAndPaymentStatus } = useCollectionAndPaymentStatus()
    const columns: ColumnOrderTableSchema<PayMCopyDateModelTypeComplete> = [
        {
            id: 'selected',
            dataKey: 'selected',
            label: '',
            simpleLabel: t('selectLine', 'Seleccionar línea'),
            width: 50,
            requiredColumn: true,
            component: 'ITCheckbox',
            headerClassName: 'checkbox_header_filter',
        },
        {
            id: 'date',
            dataKey: 'date',
            label: t('date', 'Fecha'),
        },
        {
            id: 'status',
            dataKey: 'status',
            label: t('status', 'Estado'),
            customRender: (parameterValue) => <DisplayStatus text={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.name} colorText={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.colorText} icon={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.icon} />,

        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('totalAmount', 'Importe total'),
            component: 'ITDisplayPrice',
            className: 'display_price_left'
        },
        {
            id: 'PaymentMethodId',
            dataKey: 'PayTCopy.name',
            label: t('paymentType', 'Tipo de pago'),
            customRender: (parameterValue, allRowData)=> <CustomRenderString value={allRowData?.PayTCopy?.name || ''} />
        },
        {
            id: 'PayTCopy.new_extra_payment_data',
            dataKey: 'PayTCopy.new_extra_payment_data',
            label: t('paymentInfo', 'Información de pago'),
            customRender: (parameterValue, allRowData)=> <RenderExtraPaymentData allRowData={allRowData} />
        },
    ] 
    const { parsedColumns, myGroupPaymentMethodDate, setMyGroupPaymentMethodDate, handleSubmit, loading } = useModalGroupPaymentMethodDateLogic({columns, paymentCopyDates, components: { ...sellOrderLayoutComponents, CheckboxComponent: SelectedCheckbox, ITRectangularInput: CustomRenderString, ITDisplayFinalPrice: RenderExtraPaymentData }, dictPaymentTypes, paymentTypesMemo, setOpened,...logic })

    const { setSelectedColumnsAndFilters } = useConfigColumns({ columns, name: 'groupPayments', })
    
    return (
        <ModalFullCentered className='modal_group_payments' opened={true} setOpened={()=>setOpened(null)} onClickOut={false}>
            <div className='flex flex-col flex-auto'>
                <div className='flex items-center mb-20'>
                    <h2><TwinTrans transKey='groupPayments'>Agrupar pagos</TwinTrans></h2>
                </div>
                <NewPaymentMethodDate {...{ myGroupPaymentMethodDate, setMyGroupPaymentMethodDate, paymentTypesMemo, dictPaymentTypes }} CurrencyId={myGroupPaymentMethodDate?.paymentCopyDates?.[0]?.CurrencyId || getISOCurrencyMain()}/>
                <div className='mt-30 flex flex-col flex-auto' >
                    <div className={'flex flex-col flex-auto h-1 min-h-300 '}>
                        <div className='flex-auto input_table_table'>
                            <TableWithCustomVirtualListing columns={parsedColumns} data={myGroupPaymentMethodDate?.paymentCopyDates || []} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} name={'groupPayments'} updateEmployeeParameter={true} headerChanges={{ changeOrder: () => { }, changeSingleField: () => { } }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex items-center gap-x-10 justify-end mt-20'>
                <ButtonSecondary onClick={() => setOpened(null)}>
                    <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                </ButtonSecondary>
                <ButtonDisabledOrLoader loading={loading} buttonIsDisabled={(myGroupPaymentMethodDate?.selectedTableData?.length || 0) < 2} onClick={handleSubmit} textButton={t('save', 'Guardar')} />
            </div>
        </ModalFullCentered>
    )
}

interface ModalGroupPaymentMethodDateLogicProps extends ModalGroupPaymentMethodDateBaseProps {
    columns: ColumnOrderTableSchema<any>
    components: DictionaryComponents
}

const useModalGroupPaymentMethodDateLogic = ({ paymentCopyDates, columns, components, paymentTypesMemo, dictPaymentTypes, onSubmit, setOpened }: ModalGroupPaymentMethodDateLogicProps) => {
    const [myGroupPaymentMethodDate, setMyGroupPaymentMethodDate] = useState<GroupPaymentMethodDateTy>({ info: { quantity: 0 }, paymentCopyDates: parsePaymentMethodDatesToGroup(paymentCopyDates), selectedTableData: []})
    const {t} = useTwinTranslation()
    const completePaymentTypeErr = t('setAllPaymentTypes', 'Debes configurar todos los tipos de pago')
    const completeInfoPaymentErr = t('setAllPaymentInformation', 'Debes configurar toda la información de pago')
    const {startLoading, endLoading, loading} = useIsLoading()
    
    const handleSubmit = useCallback(async () => {
        startLoading()
        if(myGroupPaymentMethodDate){
            const copy = JSON.parse(JSON.stringify(myGroupPaymentMethodDate.info))
            if (!copy.PaymentTypeId) {
                changeErrorMessage(completePaymentTypeErr)
                endLoading()
                return false
            }
            const hasComponent = dictPaymentTypes?.[paymentTypesMemo[copy?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].component !== NullComponent
            if (hasComponent && !copy.payment_data) {
                changeErrorMessage(completeInfoPaymentErr)
                endLoading()
                return false
            }
            if (copy.payment_data) {
                copy.new_extra_payment_data = { 'value': copy.payment_data }
            }
            const extraProps = dictPaymentTypes?.[paymentTypesMemo[copy?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].extraProps
            if (extraProps?.items) {
                const payment_data = extraProps?.items?.[copy.payment_data]
                copy.new_extra_payment_data = {
                    iban: payment_data?.iban,
                    name: payment_data?.name,
                    id: payment_data?.id,
                }
            }
            copy.PayMCopyId = paymentCopyDates[0].PayMCopyId
            copy.date = getStartOfDay(copy.date)
            setOpened(null)
            const result = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/groupPaymentMethodCopyDates', {
                new: copy,
                oldIds: myGroupPaymentMethodDate?.selectedTableData || []
            })
            if(result){
                onSubmit?.()
            }
        }
        endLoading()
    }, [myGroupPaymentMethodDate, completeInfoPaymentErr, completePaymentTypeErr, dictPaymentTypes, paymentCopyDates, paymentTypesMemo, onSubmit, setOpened, startLoading, endLoading])

    const selectAllLines = useCallback((checked: boolean) => {
        setMyGroupPaymentMethodDate((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            const selectedTableData = []
            for (const key in copyOld.paymentCopyDates) {
                let myElement = copyOld.paymentCopyDates[key]
                myElement.selected = checked
                if (myElement.selected && !myElement.processed) {
                    selectedTableData.push({ id: myElement.id })
                }
                if(checked){
                    copyOld.info.quantity = roundNumberAndDecimals(copyOld.info.quantity + parseFloat(String(myElement.quantity)), totalCalculateParams)
                }
            }
            if(!checked){
                copyOld.info.quantity = 0
            }
            return { ...copyOld, selectedTableData: selectedTableData }
        })
    }, [setMyGroupPaymentMethodDate])
    
    const changeSelectedOneLine = useCallback((checked: boolean, pos: number) => {
        setMyGroupPaymentMethodDate((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld?.paymentCopyDates) {
                copyOld.paymentCopyDates[pos]['selected'] = checked
                if(checked){
                    copyOld.info.quantity = roundNumberAndDecimals(copyOld.info.quantity + parseFloat(String(copyOld.paymentCopyDates[pos].quantity)), totalCalculateParams)
                }else {
                    copyOld.info.quantity = roundNumberAndDecimals(copyOld.info.quantity - parseFloat(String(copyOld.paymentCopyDates[pos].quantity)), totalCalculateParams)
                }
                copyOld['selectedTableData'] = []
                if (copyOld.paymentCopyDates) {
                    for (const key in copyOld.paymentCopyDates) {
                        const element = copyOld.paymentCopyDates[key]
                        if (element.selected) {
                            copyOld.selectedTableData.push({id: element.id})
                        }
                    }
                }
            }
            return { ...copyOld }
        })
    }, [setMyGroupPaymentMethodDate])
    
    const selectedLength = myGroupPaymentMethodDate?.selectedTableData?.length || 0

    const addCustomRender = useCallback((columns: any[]) => {
        let result: ColumnConfiguration[] = []
        if (components) {
            for (const key in columns) {
                let column = columns[key]
                const myElement = column as ColumnConfiguration
                const Element = components?.[column.component]
                if (column.component === 'ITCheckbox') {
                    const originalLength = myGroupPaymentMethodDate?.paymentCopyDates?.length || 0
                    const selectedLength = myGroupPaymentMethodDate?.selectedTableData?.length || 0
                    const isChecked = selectedLength > 0 && selectedLength === originalLength
                    const disabled = column?.extraProps?.disabled || false
                    const nextStepNotFinished = column?.extraProps?.nextStepNotFinished || false
                    const readOnlyFnc = column?.extraProps?.readOnlyFnc || false
                    column.dataKey = isChecked ? 'selected_full' : 'selected_not_full'
                    myElement.label = () => <Checkbox label={''} onChange={selectAllLines} checked={isChecked} disabled={disabled} />
                    let MyCheckboxComponent = components?.['CheckboxComponent']
                    myElement.customRender = (parameterValue: any, allRowData: any) => <MyCheckboxComponent key={'select' + parameterValue} {...{ parameterValue, allRowData, nextStepNotFinished, readOnlyFnc }} value={allRowData?.selected === true} onChange={(checked: boolean) => changeSelectedOneLine?.(checked, allRowData?.absoluteIndex || allRowData?.rowIndex)} />
                }
                if (Element) {
                    myElement.customRender = (value, allRowData) => <Element {...column as any} {...{ value, allRowData }} CurrencyId={allRowData?.CurrencyId} />
                }
                result.push(myElement)
            }
        }
        return result
    }, [myGroupPaymentMethodDate?.paymentCopyDates?.length, myGroupPaymentMethodDate?.selectedTableData?.length, changeSelectedOneLine, selectAllLines, components])



    const parseColumns = useCallback((columns: ColumnITLayoutTableConfiguration[]) => {
        let result = addCustomRender(columns as any)
        return result
    }, [addCustomRender])

    const parsedColumns = useMemo(() => parseColumns(columns), [columns, parseColumns])
    return { parsedColumns, selectedLength, myGroupPaymentMethodDate, setMyGroupPaymentMethodDate, handleSubmit, loading }
}

interface NewPaymentMethodDateProps extends NewPaymentMethodDateLogicProps {
    CurrencyId: string
    dictPaymentTypes: DictPaymentTypesTy
    myGroupPaymentMethodDate: GroupPaymentMethodDateTy
    paymentTypesMemo: TwinDictionary
}

const NewPaymentMethodDate: React.FC<NewPaymentMethodDateProps> = ({ myGroupPaymentMethodDate, CurrencyId, paymentTypesMemo, dictPaymentTypes, ...logic }) => {
    const {t} = useTwinTranslation()
    const {handleChangeField } = useNewPaymentMethodDateLogic({...logic})
    const element = dictPaymentTypes?.[paymentTypesMemo[(myGroupPaymentMethodDate?.info?.PaymentTypeId || 1)]?.relatedType as PaymentRelatedTypesKeys]
    const Component = element?.component || NullComponent
    const myValue = myGroupPaymentMethodDate?.info?.new_extra_payment_data?.id || myGroupPaymentMethodDate?.info?.new_extra_payment_data?.value || myGroupPaymentMethodDate?.info?.payment_data
    return (
        <div>
            <span className='regular18'><TwinTrans transKey='infoNewPayment'>Información nuevo pago</TwinTrans></span>
            <div className='flex items-end gap-x-20 flex-auto'>
                <InputCalendarStateFull label={t('date', 'fecha')} value={myGroupPaymentMethodDate?.info.date} onChange={(value) => handleChangeField('date', value)} minDate={new Date()} onlyValids={true} required={true} />
                <div>
                    <label className=' input_field_label input_label_up'><TwinTrans transKey='quantity'>Cantidad</TwinTrans></label>
                    <RectangularInputPrice readOnly={true} label={''} CurrencyId={CurrencyId} value={myGroupPaymentMethodDate?.info?.quantity || 0}/>
                </div>
                <CustomSelectWithSearchBar className='w-200' items={paymentTypesMemo} label={t('paymentTypeN', 'Tipo de pago')} sortItems={true} sortFunction={emptyExtraLineFirstSortFunction} value={myGroupPaymentMethodDate?.info.PaymentTypeId} onChange={(value) => handleChangeField('PaymentTypeId', parseInt(value))} required={true} />
                <Component {...element?.extraProps} className={'w-200 ' + (element?.extraProps?.className || '')} label={t('infoPayment', 'Información del pago')} value={myValue} onChange={(value: any) => handleChangeField('payment_data', value)} required={true} />
            </div>
        </div>
    )
}

interface NewPaymentMethodDateLogicProps {
    setMyGroupPaymentMethodDate: SetGroupPaymentMethodDateTy
}

const useNewPaymentMethodDateLogic = ({ setMyGroupPaymentMethodDate }: NewPaymentMethodDateLogicProps) => {
    const handleChangeField = useCallback((field: string, value: any) => {
        setMyGroupPaymentMethodDate((old)=>{
            if(!old){
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.info[field] = value
            return {...copyOld}
        })
    }, [setMyGroupPaymentMethodDate])

    return { handleChangeField }
}

interface SelectedCheckboxProps extends ITCheckboxProps { }

const SelectedCheckbox: React.FC<SelectedCheckboxProps> = ({ value, onChange }) => {
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} />
}

interface RenderExtraPaymentDataProps {
    allRowData: RowData
}

const RenderExtraPaymentData: React.FC<RenderExtraPaymentDataProps> = ({ allRowData }) => {
    const parsedValue = (allRowData?.PayTCopy?.new_extra_payment_data?.name ? (allRowData?.PayTCopy?.new_extra_payment_data?.name + ' - ' + allRowData?.PayTCopy?.new_extra_payment_data?.iban) : allRowData?.PayTCopy?.new_extra_payment_dat?.value || '-')
    return <CustomRenderString value={parsedValue} />
}

export default ModalGroupPaymentMethodDate